import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Theme, useMediaQuery } from "@mui/material";
import { Account } from "@rentablo/api/apiv1";
import { AccountsTable } from "./AccountsTable";

type Props = {
  accounts?: Account[];
  onConfirm: () => void;
  onSelect: (ids: number[]) => void;
  checkedPortfolios: number[];
  onClose?: () => void;
};

export const DepotsSelectorBody = ({
  accounts,
  checkedPortfolios = [],
  onSelect,
  onConfirm,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Box display="flex" flexDirection="column" height="calc(100% - 70px)">
      <AccountsTable
        accounts={accounts}
        checkedPortfolios={checkedPortfolios}
        onSelect={onSelect}
      />
      <Box
        position="sticky"
        bottom={0}
        zIndex={1}
        display="flex"
        justifyContent="space-between"
        gap={3}
        mt={8}
        py={4}
        bgcolor="background.paper"
      >
        <Button variant="tertiary" onClick={onClose} fullWidth={isSm}>
          {t("navigation.previous")}
        </Button>
        <Button
          data-testid="create-depots-list"
          variant="primary"
          onClick={onConfirm}
          disabled={!checkedPortfolios.length}
          fullWidth={isSm}
        >
          {t("depotsSelect.saveButton")}
        </Button>
      </Box>
    </Box>
  );
};
